module.exports = __webpack_public_path__ + "static/media/userMenu.c35f039e.svg";